/**
 * @generated SignedSource<<3e6359deb95d29f84da31829c0fd5ebc>>
 * @relayHash 784eb81584ff60b20ad802add7a860b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 396cfb0e77d3f5d2d3be19c191884a1eb98d20638e1a1c0af526217e72cc9c41

import type { ConcreteRequest } from 'relay-runtime';
export type WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation$variables = {
  id: string;
  includeChildren?: boolean | null | undefined;
};
export type WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation$data = {
  readonly watchContent: {
    readonly content: {
      readonly currentUserIsWatchingChildren: boolean | null | undefined;
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation = {
  response: WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation$data;
  variables: WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeChildren"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "id"
          },
          {
            "kind": "Literal",
            "name": "currentUser",
            "value": true
          },
          {
            "kind": "Variable",
            "name": "includeChildren",
            "variableName": "includeChildren"
          }
        ],
        "kind": "ObjectValue",
        "name": "watchContentInput"
      }
    ],
    "concreteType": "WatchContentPayload",
    "kind": "LinkedField",
    "name": "watchContent",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "currentUserIsWatchingChildren"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "784eb81584ff60b20ad802add7a860b0",
    "id": "396cfb0e77d3f5d2d3be19c191884a1eb98d20638e1a1c0af526217e72cc9c41",
    "metadata": {},
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation",
    "operationKind": "mutation",
    "text": "mutation WatchSettingsCheckboxItemsWatchDialogUnwatchChildrenMutation($id:ID!,$includeChildren:Boolean){watchContent(watchContentInput:{contentId:$id,currentUser:true,includeChildren:$includeChildren}){content{id,currentUserIsWatchingChildren}}}"
  }
};
})();

(node as any).hash = "c9440fa8475983e8d6fcad9b24ce5d57";

export default node;
